import { render, staticRenderFns } from "./occupationEdit.vue?vue&type=template&id=b407018a&scoped=true&"
import script from "./occupationEdit.vue?vue&type=script&lang=ts&"
export * from "./occupationEdit.vue?vue&type=script&lang=ts&"
import style0 from "./occupationEdit.vue?vue&type=style&index=0&id=b407018a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b407018a",
  null
  
)

export default component.exports